// eslint-disable-next-line
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../logo/Logo";
import { GoSearch } from "react-icons/go";
import { PiShoppingCartLight } from "react-icons/pi";
import Role from "../../common/Role";
import { setIsAdmin } from "../../store/adminSlice";
import UserContext from "../../context/context";
import { BsPersonFillCheck } from "react-icons/bs";
import LogOutPage from "../../pages/LogOutPage";
import { IoHeart } from "react-icons/io5";

const Header = ({ UserDetails, cartCount }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.user?.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [menu, setMenu] = useState(false);
  const context = useContext(UserContext);
  const [query, setQuery] = useState("");
  const [searchValue] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const inputRef = useRef(null); // Ref for the search input
  const searchContainerRef = useRef(null);

  const menuRef = useRef(null);

  const handleSearch = (e) => {
    // Navigate to search page with search query
    const value = e.target.value;
    if (e.key === " ") {
      // Check if the space key is pressed
      e.preventDefault();
    }
    // history.push(`/search-cart?query=${query}`);
    // console.log("Search value:", value);
    setQuery(e.target.value);

    if (value) {
      navigate(`/search-cart?query=${value}`);
    } else {
      navigate("/");
    }
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleCombinedChange = (e) => {
    handleInputChange(e);
    handleSearch(e); // Call search when the input changes
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenu(false); // Close the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    context.fetchCartCount();
    // Call cartCount function if it's a function
    if (typeof cartCount === "function") {
      cartCount();
    }

    const checkUserRole = async () => {
      if (user) {
        if (user.role === Role.ADMIN) {
          dispatch(setIsAdmin(true));
        } else {
          dispatch(setIsAdmin(false));
        }
      }
    };

    checkUserRole();
  }, [user, dispatch, cartCount, context]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className=" bg-white fixed w-full z-50 shadow-sm ">
      <div className="container flex w-full py-2 items-center mx-auto justify-between px-[10px] flex-wrap">
        <div className="flex items-center">
          <Link to="/" title="Home">
            <Logo />
          </Link>
        </div>

        <div className="hidden lg:flex items-center justify-center w-[400px] relative">
          <input
            ref={inputRef}
            onChange={handleCombinedChange} // Handle input change
            onKeyDown={handleSearch}
            onClick={handleSearch}
            type="text"
            value={query || searchValue}
            placeholder="Search by product name..."
            className="border-2 border-gray-100 shadow-sm rounded p-2 px-4 w-full outline-none h-[35px] transition-all hover:shadow-md"
          />
          <div className=" w-10 h-[35px] rounded absolute right-0 flex items-center justify-center">
            <span className="text-slate-500">
              <GoSearch />
            </span>
          </div>
        </div>

        <div style={{ fontSize: "25px" }} className="flex items-center gap-5 ">
          <span
            className="text-slate-500 cursor-pointer md:hidden "
            onClick={() => setIsSearchOpen((prev) => !prev)}
          >
            <GoSearch />
          </span>

          {!isAuthenticated ? (
            <div className="hidden">
              {isAuthenticated && (
                <span
                  className="relative flex text-gray-400 hover:text-blue-400 cursor-pointer "
                  title="Profile"
                  onClick={() => setMenu((prev) => !prev)}
                >
                  {/* <CgProfile /> */}
                  <BsPersonFillCheck />
                </span>
              )}

              {menu && (
                <menu className="absolute top-[44px] right-[-70px] mx-auto bg-white shadow-md rounded-md  w-[150px] z-10">
                  <nav>
                    <ul className="flex items-center gap-[5px] justify-center whitespace-nowrap flex-col text-[18px] transition-all">
                      {user?.role === Role.ADMIN && (
                        <>
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="/admin-panel/all-orders"
                              onClick={() => setMenu(false)}
                            >
                              Admin
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />

                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="user-profile"
                              onClick={() => setMenu(false)}
                            >
                              Profile
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link to="/order" onClick={() => setMenu(false)}>
                              Orders
                            </Link>
                          </li>
                        </>
                      )}
                      <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />

                      {user?.role === Role.GENERAL && (
                        <>
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="user-profile"
                              onClick={() => setMenu(false)}
                            >
                              Profile
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link to="/order" onClick={() => setMenu(false)}>
                              Orders
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </nav>
                </menu>
              )}
            </div>
          ) : (
            <div className="relative">
              {isAuthenticated && (
                <span
                  className="relative flex text-gray-400 hover:text-blue-400 cursor-pointer "
                  title="Profile"
                  onClick={() => setMenu((prev) => !prev)}
                >
                  {/* <CgProfile /> */}
                  <BsPersonFillCheck />
                </span>
              )}

              {menu && (
                <menu className="absolute top-[44px] right-[-70px] mx-auto bg-white shadow-md rounded-md  w-[150px] z-10">
                  <nav>
                    <ul className="flex items-center gap-[5px] justify-center whitespace-nowrap flex-col text-[18px] transition-all">
                      {user?.role === Role.ADMIN && (
                        <>
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="/admin-panel/all-orders"
                              onClick={() => setMenu(false)}
                            >
                              Admin
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />

                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="user-profile"
                              onClick={() => setMenu(false)}
                            >
                              Profile
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link to="/order" onClick={() => setMenu(false)}>
                              Orders
                            </Link>
                          </li>
                        </>
                      )}
                      <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />

                      {user?.role === Role.GENERAL && (
                        <>
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link
                              to="user-profile"
                              onClick={() => setMenu(false)}
                            >
                              Profile
                            </Link>
                          </li>
                          <hr className="hidden md:block w-[95%] mx-auto bg-[#ED48FF] h-[1px]" />
                          <li className="  cursor-pointer w-[100%] text-center py-2 hover:bg-slate-100 ">
                            <Link to="/order" onClick={() => setMenu(false)}>
                              Orders
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </nav>
                </menu>
              )}
            </div>
          )}

          {isAuthenticated && (
            <>
              <Link to={"/cart"} className="relative">
                <span className="text-gray-950 cursor-pointer">
                  <PiShoppingCartLight />
                </span>
                <p className="absolute text-sm bg-[#c6f7ef] text-black font-bold -right-2 -top-4 rounded-full w-6 h-6 flex items-center justify-center">
                  {" "}
                  {context?.cartCount || 0}{" "}
                </p>
              </Link>

              {/* <span className=" cursor-pointer animate-pulse text-3xl text-[#6fdedc] ">
<Link to="/wishlist-products">
  <IoHeart />
</Link>
</span> */}
            </>
          )}

          <span className=" cursor-pointer animate-pulse text-3xl text-[#6fdedc] ">
            <Link to="/wishlist-products">
              <IoHeart />
            </Link>
          </span>

          {isAuthenticated ? (
            <div className="hidden md:block">
              <LogOutPage />
            </div>
          ) : (
            <div className="flex bg-black hover:bg-main-background py-1 font-semibold px-4 text-white w-[80px] transition-all duration-200 text-center items-center justify-center rounded-md">
              <Link to="sign-in" style={{ fontSize: "18px" }}>
                Login
              </Link>
            </div>
          )}
        </div>

        {isSearchOpen && (
          <div className="absolute top-[50px] left-0 right-0 z-10">
            {/* Overlay background */}
            <div className="fixed inset-0 bg-black opacity-50 z-0"></div>

            <div
              ref={searchContainerRef}
              className="flex items-center justify-center w-[300px]  relative mx-auto mb-2 transition-all duration-500 transform translate-y-0 z-10"
              style={{ transition: "transform 0.5s ease-out" }}
            >
              <input
                ref={inputRef}
                onChange={handleCombinedChange} // Handle input change
                onKeyDown={handleSearch}
                onClick={handleSearch}
                type="text"
                value={query || searchValue}
                placeholder="Search by product name..."
                className="border-2 border-gray-100 shadow-sm rounded h-[45px] p-2 px-4 w-full outline-none transition-all hover:shadow-md"
              />
              <div className="w-10 h-[35px] rounded absolute right-0 flex items-center justify-center">
                <span className="text-slate-500">
                  <GoSearch />
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
